export default __webpack_public_path__ + "static/media/adebola-ige.a304240e.png";